/**
 * Shared eScript failure copy.
 *
 * The dropped-items guidance reaches the shopper through whichever channel their landing has:
 * `EScriptCartAlerts` in checkout, the add-to-cart toast everywhere else (see `reportFailedItems`).
 * Only one renders at a time, so both need the full text, and keeping it here is what stops the two
 * from drifting apart -- they previously held byte-identical copies (sc-137931).
 */
export const droppedItemsGuidance =
  'Either the prescription link was incorrect or the product is currently unavailable. Please double check your order and contact your practitioner about any concerns.'
